module.exports = __webpack_public_path__ + "static/img/p9.457ed30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/p9.jpg
// module id = yJ6L
// module chunks = 0